import { CSSProperties, createContext, RefObject, useContext } from 'react';

interface PageContextValue {
  stickyStyle: CSSProperties;
  scrollableContentRef: RefObject<HTMLElement>;
}

export const PageContext = createContext<PageContextValue>({
  stickyStyle: {},
  scrollableContentRef: { current: null },
});

export const usePageContext = () => useContext(PageContext);
